var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"prllx"},[_c('div',{staticClass:"bgParallax",attrs:{"id":_vm.id,"data-speed":"15"}},[_c('article',[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }